<template lang="pug">
#NearestSchools(v-if="schools")
    h4 The closest {{ boundarySetTitle.toLowerCase() }} schools to this address are:
    .fine-print(v-if="specialistView") Your child may need specific assessments to determine if they are eligible to attend a specialist school. Families should contact the school for more information.
    p.fine-print (indicative distances measured by a straight line between the address and the school)
    .container(v-for="school in schools")
        .school-summary-header
            .school-name {{ school.properties.School_Name }}
            .distance {{ distanceTo(school.geometry) }} km
        .key-detail(v-if="specialistView")
            p Specialisation: {{ school.properties.Specialisation }}
        .key-detail(v-else) Years: {{ school.properties.Campus_Year_Levels }}
        .goto
            a(href="#" @click="click(school, $event)") See more
</template>

<script>
import distance from '@turf/distance';
import { EventBus } from './EventBus';
export default {
    name: 'NearestSchools',
    data: () => ({
        schools: undefined,
    }),
    computed: {
        specialistView() {
            return window.app.BoundarySelector.year === 'specialist';
        },
        boundarySetTitle() {
            return window.app.BoundarySelector.boundarySetTitle;
        },
        stage() {
            return window.app.BoundarySelector.stage;
        },
    },
    created() {
        window.app.NearestSchools = this;
    },
    methods: {
        distanceTo(point) {
            return (
                Math.round(
                    distance(window.app.AddressSearch.addressPoint, point) * 100
                ) / 100
            );
        },
        click(school, event) {
            event.preventDefault();
            EventBus.$emit('school-select', school, true);
            this.$nextTick(() =>
                document.getElementById('SchoolInfo').scrollIntoView()
            );
            window.track('App', 'see-more', 'nearest-schools');
        },
    },
};
</script>

<style scoped>
h4 {
    margin: 0;
}

.container {
    background: #e8effc;
    padding: 1em;
    border-radius: 3px;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    border: 1px solid grey;
    margin-bottom: 10px;
    font-size: 14px;
}

.school-summary-header {
    font-size: 14px;
    display: flex;
}

.school-name {
    font-weight: bold;
    flex: auto;
}

.distance {
    text-align: right;
    min-width: 4em;
    max-width: 4em;
    margin-left: 0.5em;
}

.goto {
    margin-top: 1em;
}
</style>
